<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <p class="is-size-4 has-text-weight-bold">
        {{ $t('ligneRegroupementPersonnalisee.popUpInformation.title') }}
      </p>
      <p class="has-text-grey is-size-7 mgt-5px">
        {{ getTotalDiffusion > 0 ? $t('ligneRegroupementPersonnalisee.popUpInformation.subTitle',
        { nbProduit: allInformationRegroupement.length,
          nbDiffusion: getTotalDiffusion.toLocaleString(),
          nbEcran: getTotalEcran.toLocaleString()}) :
        $t('ligneRegroupementPersonnalisee.popUpInformation.subTitle2',
        { nbProduit: allInformationRegroupement.length})}}
      </p>
      <v-client-table :data="allInformationRegroupement" :columns="columns" :options="options"
                      class="mgt-20px"
                      ref='tableInformationRegroupementPersonalise'>
        <div slot="libelle" slot-scope="props" v-html="props.row.libelle">
        </div>
        <div slot="nbEcran" slot-scope="props" class="is-pulled-right">
          {{ (props.row.type === CATEGORIE_REGROUPEMENT_NUMERIQUE
          ? props.row.nbEcran : '') | formatLocaleString}}
        </div>
        <div slot="nbDiffusion" slot-scope="props" class="is-pulled-right">
          {{ (props.row.type === CATEGORIE_REGROUPEMENT_NUMERIQUE
          ? props.row.nbDiffusion : '') | formatLocaleString}}
        </div>
      </v-client-table>
    </div>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import {
  TEXTS, SORT_ICON, NO_PER_PAGE_VALUE, RESULTS_PER_POP_UP,
} from '@/configuration/clientTableConf';
import getInformationRegroupement from '@/services/devisCommandes/InformationLigneRegroupementCalcul';
import messageErreur from '@/services/general/messageErreur';
import {
  CATEGORIE_REGROUPEMENT_NUMERIQUE,
} from '@/configuration/catalogue/produitConf';

export default {
  name: 'informationRegroupementPersonnalise',
  data() {
    return {
      allInformationRegroupement: [],
      CATEGORIE_REGROUPEMENT_NUMERIQUE: CATEGORIE_REGROUPEMENT_NUMERIQUE,
    };
  },
  props: {
    lignesCommande: {
      type: Array,
      required: true,
      default: null,
    },
  },
  computed: {
    getTotalEcran() {
      let total = 0;
      this.allInformationRegroupement.forEach((el) => {
        total += el.nbEcran;
      });
      return total;
    },
    getTotalDiffusion() {
      let total = 0;
      this.allInformationRegroupement.forEach((el) => {
        total += el.nbDiffusion;
      });
      return total;
    },
    columns() {
      return [
        'produitCode',
        'libelle',
        'nbEcran',
        'nbDiffusion',
      ];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        headings: {
          produitCode: this.$i18n.t('ligneRegroupementPersonnalisee.popUpInformation.produit'),
          libelle: this.$i18n.t('ligneRegroupementPersonnalisee.popUpInformation.libelle'),
          nbEcran: this.$i18n.t('ligneRegroupementPersonnalisee.popUpInformation.nbEcran'),
          nbDiffusion: this.$i18n.t('ligneRegroupementPersonnalisee.popUpInformation.nbDiffusion'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
        texts: TEXTS,
        sortIcon: SORT_ICON,
        sortable: [
          'produitCode',
          'libelle',
          'nbEcran',
          'nbDiffusion',
        ],
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.allInformationRegroupement = await getInformationRegroupement(this.lignesCommande);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
